// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Y4lz","transparent":"Header_transparent__26dIl","actions":"Header_actions__2FDaJ"};